module.exports = __webpack_public_path__ + "6d4bfc8e1517819dbed4503af531e5eb.jpg";